export const STAGE_KEY = 'attraction';

export const STAGE_CONFIG = {
  id: 'fase2',
  label: 'Generacion inteligente',
  questionOrder: [
    'requestedService',
    'prospectos',
    'presupuestoMesa',
    'ticket',
    'productionCost',
    'recurringPayments',
    'recurringValue',
    'newClients',
    'closeRate',
    'marketCpl',
    'qualifiedCpl',
    'marketingPercent',
    'userEmail',
    'userPhone',
  ],
  coreFields: [
    'presupuestoMesa',
    'ticket',
    'productionCost',
    'newClients',
    'closeRate',
    'marketCpl',
    'qualifiedCpl',
    'marketingPercent',
    'userEmail',
    'userPhone',
  ],
  serviceIds: ['gen-seo', 'gen-google', 'gen-social', 'gen-blog', 'gen-reels', 'gen-imagenes'],
  questions: {
    requestedService: '¡Excelente {userName}! Dado que ya tenemos la base, vamos con el motor de atraccion. ¿Que canal quiere activar primero: SEO, Google Ads, Meta Ads o el sistema completo de captacion?',
    prospectos: '¿Y hoy como le llegan sus prospectos? ¿Por recomendacion, Google, redes sociales o siente que casi no estan llegando?',
    presupuestoMesa: 'Para que la pauta no se quede corta, ¿con que presupuesto mensual cuenta hoy para atraer clientes (publicidad y gestion)?',
    ticket: 'De esos servicios que desea impulsar ({priorityOffering}), ¿que valor tiene el contrato o ticket promedio por cliente?',
    productionCost: 'Para entender sus margenes, ¿cuanto le cuesta operativamente entregar el servicio a cada cliente nuevo?',
    recurringPayments: '¿Y sus clientes suelen tener pagos de renovacion o recurrencias despues de ese primer mes?',
    recurringValue: 'Buenisimo. ¿Y de cuanto suelen ser esos pagos extras o mensualidades de recurrencia?',
    newClients: 'Para que el retorno valga la pena, ¿cuantos clientes nuevos al mes nos pondremos como meta?',
    closeRate: 'De cada 10 oportunidades reales que le llegan hoy, ¿cuantas terminan dandole el "si"? (Este dato es clave para el calculo de viabilidad).',
    marketCpl: 'Si ya ha probado anuncios, ¿tiene una idea de cuánto le cuesta hoy captar cada contacto o lead crudo?',
    qualifiedCpl: 'Entendido, pero ¿tiene claro cuánto le termina costando generar un prospecto calificado o una reunión comercial real (CPL Calificado)?',
    marketingPercent: '¿Que porcentaje de su utilidad estaria dispuesto a reinvertir para seguir escalando esta maquina de atraccion?',
    userEmail: 'Ya casi terminamos. Para mandarle su análisis detallado, ¿a qué correo se lo comparto?',
    userPhone: 'Y por si se corta la conexión antes de darle sus resultados, ¿cuál es su WhatsApp o número de contacto?',
  },
};

const attractionGuide = {
  role: 'Asesor de trafico, demanda y captacion.',
  detectWhen: [
    'La marca ya existe o esta suficientemente armada.',
    'El usuario pide campanas, publicidad, SEO, contenidos, reels o leads.',
  ],
  firstQuestions: [
    'Que busca activar primero: SEO, Google Ads, Meta Ads, blog, reels o todo el sistema?',
    'Cuanto cobra aproximadamente por contrato o ticket?',
  ],
  thenAsk: [
    'Cuanto le cuesta operativamente entregar el servicio?',
    'Cuantos clientes nuevos quiere por mes?',
    'De cada 10 oportunidades reales, cuantas terminan cerrando?',
    'Cuanto le cuesta hoy captar un contacto crudo?',
    'Cuanto le cuesta generar una reunion o prospecto calificado?',
    'Que presupuesto mensual puede sostener entre publicidad y gestion?',
    'Que porcentaje de su utilidad reinvierte en marketing y ventas?',
  ],
  avoidForNow: [
    'No empujes atraccion si todavia no hay base de marca suficiente.',
  ],
  mustExplain: [
    'Aqui se valida si se puede pagar agencia y publicidad por al menos 3 meses.',
    'La meta es saber si el negocio puede invertir para ganar o si primero hay que ajustar estructura.',
  ],
  services: [
    'SEO y optimizacion on-page',
    'Campanas en Google Ads',
    'Campanas en redes sociales',
    'Creacion continua de articulos del blog',
    'Reels y piezas cortas de atraccion',
    'Imagenes y creatividades para campanas',
  ],
};

export default attractionGuide;
